import { PageContainer, PageHeader } from '@/components/Atoms'
import { PageError } from '@/components/PageError'
import { PageLoader } from '@/components/PageLoader'
import usePermissions from '@/hooks/permissions/usePermissions'
import { useCrtNotificationSubscriptions } from '@/hooks/queries/crt/useCrtNotifications'
import { useRoles } from '@/hooks/queries/crt/useRoles'
import { useMe } from '@/hooks/queries/useMe'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NotificationsEditor } from './-components/NotificationsEditor'

export const Route = createFileRoute('/_auth/_modules/crt/admin/notifications/')({
  component: NotificationsPage,
})

function NotificationsPage() {
  const { t } = useTranslation('crt')
  const { canUser } = usePermissions()
  const canManage = canUser('crt_notifications_manage')
  const { data: me } = useMe()

  const { data: roles } = useRoles()
  const { data: subscriptions, isPending, error } = useCrtNotificationSubscriptions()
  // Bumped after a save so the editor remounts on the fresh server values.
  const [saveCount, setSaveCount] = useState(0)

  return (
    <PageContainer className="pb-28">
      <PageHeader>{t('notifications.page.title')}</PageHeader>

      {isPending ? (
        <PageLoader />
      ) : error ? (
        <PageError message={error.message} />
      ) : (
        <NotificationsEditor
          key={saveCount}
          subscriptions={subscriptions}
          roles={roles}
          currentUserId={me?.id}
          canManage={canManage}
          onSaved={() => setSaveCount((count) => count + 1)}
        />
      )}
    </PageContainer>
  )
}
